import { SummarizerConfig } from '../../types/summarizer';

export const socialMediaSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'social-media-summarizer',
  title: 'Social Media Summarizer',
  description: 'Summarize posts, threads, and discussions from any social media platform',
  version: '1.0.0',

  // Categorization
  category: 'social',
  tags: ['social-media', 'linkedin', 'facebook', 'instagram', 'reddit', 'threads'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // Social media content is accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter social media post URL',
      // validation: /(linkedin\.com|facebook\.com|instagram\.com|reddit\.com|threads\.net|x\.com|twitter\.com)/,
      examples: [
        'https://www.linkedin.com/posts/username_activity-123...',
        'https://www.facebook.com/username/posts/123...',
        'https://www.instagram.com/p/ABC123...',
        'https://www.reddit.com/r/topic/comments/xyz...',
        'https://www.threads.net/@username/post/ABC...',
      ],
      helpText:
        'Paste any public social media post URL to get an instant summary of the content and discussions.',
      showExamples: true,
      showHelpText: true,
    },
    text: {
      enabled: true,
      placeholder: 'Or paste the social media post content here',
      maxLength: 50000,
      minLength: 50,
      rows: 8,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: false,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'social-media',
    timeout: 30000,
  },

  // UI customization
  ui: {
    primaryColor: '#1877f2',
    secondaryColor: '#42b883',
    icon: '📱',
    theme: 'light',
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0,
    allowedDomains: [
      'linkedin.com',
      'facebook.com',
      'instagram.com',
      'reddit.com',
      'threads.net',
      'x.com',
      'twitter.com',
    ],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
